<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<div class="row">
  <div class="container">
    <div class="col-sm-1"></div>
    <div class="col-sm-10 leyenda1">
      <p>Registro Nacional de Cursos</p>
    </div>
  </div>
</div>
<br />
<div class="panel panel-danger">
  <div class="panel-heading">
    <p class="encabezado">Curso: {{ curso?.nombreCurso }}</p>
  </div>
  <br />
  <br />
  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2">
                  &nbsp;Estándar de Competencia en que se basa el curso de
                  capacitación:
                </p>
              </div>
              <br />
              <div class="col-sm-2">
                <a>
                  <img
                    src="./assets/images/icon/menu-desplegable.png"
                    class="imagen"
                    (click)="collapseOpen('collapse1', 1)"
                  />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse1" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="panel-body">
                <div class="row">
                  <div class="container">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-9">
                      <br />
                      <p class="letra" style="text-align: justify">
                        {{ curso?.estandar }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2">&nbsp;Descripción/Objetivo:</p>
              </div>
              <br />
              <div class="col-sm-2">
                <a>
                  <img
                    src="./assets/images/icon/menu-desplegable.png"
                    class="imagen"
                    (click)="collapseOpen('collapse2', 2)"
                  />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse2" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-2"></div>
                  <div class="col-sm-9">
                    <br />
                    <p class="letra" style="text-align: justify">
                      {{ curso?.descripcionObjetivo }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="container">
                  <div class="col-sm-2"></div>
                  <div class="col-sm-9">
                    <br />
                    <p>Módulos:</p>
                    <div
                      class="list-dots"
                      style="text-align: justify"
                      [innerHTML]="curso?.modulos"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />

  <br />

  <div class="row">
    <div class="container">
      <div class="panel-group">
        <div class="panel panel-default">
          <div class="panel-heading1">
            <div class="row">
              <div class="col-sm-10">
                <p class="encabezado2">&nbsp;Datos del capacitador:</p>
              </div>
              <br />
              <div class="col-sm-2">
                <a>
                  <img
                    src="./assets/images/icon/menu-desplegable.png"
                    class="imagen"
                    (click)="collapseOpen('collapse4', 4)"
                  />
                </a>
              </div>
            </div>
          </div>
          <div id="collapse4" class="panel-collapse collapse">
            <div class="panel-body">
              <div class="row">
                <div class="container">
                  <div class="col-sm-6">
                    <div class="panel-heading1">
                      <p class="encabezado2">Datos del capacitor:</p>

                      <table class="table">
                        <tr>
                          <th>
                            <p class="letraE">Nombre:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.nombreCapacitador != null
                                  ? curso?.capacitador.nombreCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Calle y Número:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.calleYNumeroCapacitador !=
                                null
                                  ? curso?.capacitador.calleYNumeroCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Colonia:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.coloniaCapacitador != null
                                  ? curso?.capacitador.coloniaCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Localidad:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.localidadCapacitador != null
                                  ? curso?.capacitador.localidadCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Entidad Federativa:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador
                                  .entidadfederativaCapacitador != null
                                  ? curso?.capacitador
                                      .entidadfederativaCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Municipio:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.municipioCapacitador != null
                                  ? curso?.capacitador.municipioCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Código Postal:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.codigoPostalCapacitador !=
                                null
                                  ? curso?.capacitador.codigoPostalCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Teléfonos:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.telefonosCapacitador != null
                                  ? curso?.capacitador.telefonosCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Página Web:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador.paginaWebCapacitador != null
                                  ? curso?.capacitador.paginaWebCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                        <tr>
                          <th>
                            <p class="letraE">Correo Electrónico:</p>
                          </th>
                          <th>
                            <p class="letraE">
                              {{
                                curso?.capacitador
                                  .correoElectronicoCapacitador != null
                                  ? curso?.capacitador
                                      .correoElectronicoCapacitador
                                  : "Sin datos"
                              }}
                            </p>
                          </th>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="panel-heading1"></div>
                  </div>
                </div>
              </div>
              <div class="row"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />

  <br />

  <div class="row">
    <div class="container">
      <div class="col-sm-5"></div>
      <div style="text-align: center" class="col-sm-1">
        <button mat-button (click)="close()">
          <img src="./assets/images/icon/Atras.png" class="imagen" />
        </button>
      </div>
      <div style="text-align: center" class="col-sm-1">
        <button mat-button (click)="close()">
          <img src="./assets/images/icon/Home.png" class="imagen" />
        </button>
      </div>
    </div>
  </div>
</div>
